module.exports = __webpack_public_path__ + "static/img/login-background.c1fa90c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/login-background.jpg
// module id = M+SN
// module chunks = 0